// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".infoBox[data-v-b0bc03cc] {\n  display: flex;\n  flex-wrap: wrap;\n  height: 100%;\n}\n[data-v-b0bc03cc] .ant-form-item {\n  width: 50%;\n}\n.moneyBox[data-v-b0bc03cc] {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n}", ""]);
// Exports
module.exports = exports;
